import { Theme, Colors } from '@inplayer-org/inplayer-ui';
import { rem } from 'polished';

export const light: Theme = {
  palette: {
    primary: {
      main: Colors.skyBlue,
      light: Colors.lightSkyBlue,
      dark: Colors.navy,
    },
    secondary: {
      main: Colors.blue,
      light: Colors.mediumBlue,
      dark: Colors.darkBlue,
    },
    text: {
      main: Colors.fontDarkGray,
      light: Colors.fontGray,
      disabled: Colors.fontLightGray,
    },
    background: {
      main: Colors.white,
    },
  },
  dimensions: {
    baseGrid: 8,
    borderRadius: '2px',
  },
  font: {
    primary: 'Roboto',
    weights: {
      thin: 100,
      light: 300,
      normal: 400,
      semiBold: 500,
      bold: 700,
    },
    sizes: {
      extraSmall: rem(12),
      small: rem(14),
      medium: rem(16),
      large: rem(18),
      extraLarge: rem(50),
      h1: rem(40),
      h2: rem(36),
      h3: rem(32),
      h4: rem(28),
      h5: rem(24),
      h6: rem(20),
    },
  },
  padding: {
    sizes: {
      small: '',
      medium: '',
    },
  },
};

export const dark: Theme = {
  palette: {
    primary: {
      main: Colors.skyBlue,
      light: Colors.lightSkyBlue,
      dark: Colors.navy,
    },
    secondary: {
      main: Colors.blue,
      light: Colors.mediumBlue,
      dark: Colors.darkBlue,
    },
    text: {
      main: Colors.white,
      light: Colors.fontGray,
      disabled: Colors.fontLightGray,
    },
    background: {
      main: Colors.asphalt,
      light: Colors.white,
      disabled: Colors.fontLightGray,
    },
  },
  dimensions: {
    baseGrid: 8,
    borderRadius: '2px',
  },
  font: {
    primary: 'Roboto',
    weights: {
      thin: 100,
      light: 300,
      normal: 400,
      semiBold: 500,
      bold: 700,
    },
    sizes: {
      extraSmall: rem(12),
      small: rem(14),
      medium: rem(16),
      large: rem(18),
      extraLarge: rem(50),
      h1: rem(40),
      h2: rem(36),
      h3: rem(32),
      h4: rem(28),
      h5: rem(24),
      h6: rem(20),
    },
  },
  padding: {
    sizes: {
      small: '',
      medium: '',
    },
  },
};
